export default "__VITE_ASSET__BpH2xQof__"